import { createSelector } from 'reselect';

export const getStorages = (state) => state.storages.data;

export const getStoragesOptions = createSelector(
  getStorages,
  (items) => items.map(({ id: value, name: text }) => ({ value, text })),
);

export const getStoragesLabelMap = createSelector(
  getStorages,
  (items) => items.reduce((result, { name, id }) => ({ ...result, [id]: name }), {}),
);

export const getStoragesLoadingState = ({ storages }) => storages.loading;
